import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import {
  CustomFormDetailsFragment, GetCampaignEntityTypeConfigurationGQL
} from 'generated/graphql';
import { isNilOrEmpty } from 'helpers';

@Injectable({
  providedIn: 'root'
})
export class GetCustomFormService {
  /**
   *
   */
  constructor(private _getCampaignEntityTypeConfigGQL: GetCampaignEntityTypeConfigurationGQL) {
  }

  async getContactForm(entityTypeId: string, campaignId: string): Promise<CustomFormDetailsFragment> {
    const query = this._getCampaignEntityTypeConfigGQL.fetch({ campaignId, entityTypeId });
    const entityTypeConfig = await lastValueFrom(query);
    return entityTypeConfig.data.getCampaignEntityTypeConfiguration.customForm;
  }

  async contactFormEnabled(entityTypeId: string, campaignId: string): Promise<boolean> {
    const form = await this.getContactForm(entityTypeId, campaignId);
    return !isNilOrEmpty(form?.fields);
    }
}
